export type InputType = 'text' | 'currency' | 'number' | 'percentage';

export interface InputFieldOptions {
  type: InputType;
  placeholder?: string;
  onSubmit: (value: string) => void;
}

export class InputField {
  private container: HTMLElement;
  private input: HTMLInputElement;
  private button: HTMLButtonElement;
  private options: InputFieldOptions;

  constructor(parentElement: HTMLElement, options: InputFieldOptions) {
    this.options = options;
    this.container = document.createElement('div');
    this.container.className = 'input-area';

    const wrapper = document.createElement('div');
    wrapper.className = 'input-wrapper';

    if (options.type === 'currency') {
      const currencyWrapper = document.createElement('div');
      currencyWrapper.className = 'currency-input-wrapper';

      this.input = document.createElement('input');
      this.input.type = 'text';
      this.input.placeholder = options.placeholder || '0,00';
      this.input.addEventListener('input', () => this.formatCurrency());

      currencyWrapper.appendChild(this.input);
      wrapper.appendChild(currencyWrapper);
    } else {
      this.input = document.createElement('input');
      this.input.type = options.type === 'number' || options.type === 'percentage' ? 'number' : 'text';
      this.input.placeholder = options.placeholder || 'Digite sua resposta...';
      wrapper.appendChild(this.input);
    }

    this.button = document.createElement('button');
    this.button.className = 'btn-send';
    this.button.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <line x1="22" y1="2" x2="11" y2="13"></line>
        <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
      </svg>
    `;

    wrapper.appendChild(this.button);
    this.container.appendChild(wrapper);
    parentElement.appendChild(this.container);

    this.setupEventListeners();
  }

  private setupEventListeners(): void {
    this.button.addEventListener('click', () => this.submit());

    this.input.addEventListener('keypress', (e) => {
      if (e.key === 'Enter') {
        this.submit();
      }
    });
  }

  private formatCurrency(): void {
    let value = this.input.value.replace(/\D/g, '');

    if (value.length === 0) {
      this.input.value = '';
      return;
    }

    const numValue = parseInt(value, 10) / 100;
    this.input.value = numValue.toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  private submit(): void {
    const value = this.input.value.trim();
    if (value) {
      this.options.onSubmit(value);
      this.input.value = '';
    }
  }

  focus(): void {
    this.input.focus();
  }

  disable(): void {
    this.input.disabled = true;
    this.button.disabled = true;
  }

  enable(): void {
    this.input.disabled = false;
    this.button.disabled = false;
  }

  remove(): void {
    this.container.remove();
  }

  getElement(): HTMLElement {
    return this.container;
  }
}
